/**
 * Request the location of the user.
 * By default the high accuracy setting is set to false.
 * @param {boolean} [enableHighAccuracy]
 * @returns {Promise<(GeolocationPosition|GeolocationPositionError)>}
 */
export default function getUserLocation(enableHighAccuracy = false) {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy,
        })
    })
}



// WEBPACK FOOTER //
// ./scripts/util/getUserLocation.js